import { SeoController } from '@application/components';
import { useRouter } from '@application/utils';
import { JoinEducatorPage } from '@presentation/pages';
import type { FC } from 'react';
import { useCallback } from 'react';

export const JoinEducatorPageController: FC = () => {
  const { translate, language } = useRouter();

  const onSignupClickHandler = useCallback(() => {
    const link =
      language === 'fr'
        ? 'https://forms.gle/WhmZCZXDcFPpgzsV7'
        : 'https://forms.gle/Xht3WeWSaoCE3nceA';

    window.open(link, '_blank');
  }, [language]);
  return (
    <>
      <SeoController
        title={translate('joinPro.EDUCATOR.seo.title')}
        description={translate('joinPro.EDUCATOR.seo.description')}
        keywords={translate('joinPro.EDUCATOR.seo.keywords')}
      />
      <JoinEducatorPage onSignupClick={onSignupClickHandler} />
    </>
  );
};
